export default "__VITE_ASSET__BfR6Ihy7__"